<template>
  <div class="sn-f-b-s payment-detail">
    <sn-navigator id="FYCX" :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s payment-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', initial),
        replace: true,
        router: `/query/payment?type=${paymentType}`
      }, {
        title: `${$sn.utils.getFunctionTitle('0', initial)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 detail-blank">
        <template v-if="!$sn.validate.empty(handleDetail)">
          <template v-if="paymentType === '2' && $sn.getConfig('isShowInPaymentMultipleDate')">
            <div class="table-region">
              <div class="table-region-one" v-for="item in tableData" :key="item.id">
                <div class="sn-f-b-c first-header" @click="openClose(item)">
                  <div class="sn-f-s-c">
                    <div class="iconfont sn-fc-main icon-xiangyou" :class="{'sn-tr-90': item.open}"></div>
                    <div class="sn-ph-10 sn-f-s-c">费用明细<span class="sn-ph-10">{{item.time}}</span></div>
                  </div>
                  <div class="sn-f-s-c">合计：<span class="sn-fc-red1">{{item.totalCost}}元</span></div>
                </div>
                <div class="sn-f-s-0 second" v-if="item.open">
                  <div class="sn-table">
                    <table>
                      <thead>
                      <tr>
                        <th>序号</th>
                        <th>就诊人</th>
                        <th>项目名称</th>
                        <th>单价（元）</th>
                        <th>数量</th>
                        <th>金额（元）</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="indexOne" v-for="(detail, indexOne) in item.children">
                        <td>{{ indexOne + 1 }}</td>
                        <td>{{detail.patName}}</td>
                        <td>{{detail.itemName}}</td>
                        <td>{{detail.itemUnitPrice === 0 ? '0.00' : $sn.format.priceFormat(detail.itemUnitPrice, 2)}}</td>
                        <td>{{detail.itemNum}}</td>
                        <td>{{detail.totalCost === 0 ? '0.00' : $sn.format.priceFormat(detail.itemPrice, 2)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="total-title">费用总金额：{{$sn.format.priceFormat(totalCost, 2)}}元</div>
            <div class="sn-table">
              <table>
                <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>项目名称</th>
                  <th>单价（元）</th>
                  <th>数量</th>
                  <th>金额（元）</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(detail, index) in handleDetail">
                  <td>{{ index + 1 }}</td>
                  <td>{{detail.patName}}</td>
                  <td>{{detail.itemName}}</td>
                  <td>{{detail.itemUnitPrice === 0 ? '0.00' : $sn.format.priceFormat(detail.itemUnitPrice, 2)}}</td>
                  <td>{{detail.itemNum}}</td>
                  <td>{{detail.totalCost === 0 ? '0.00' : $sn.format.priceFormat(detail.itemPrice, 2)}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </template>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination" v-if="paymentType === '1' || (paymentType === '2' && !$sn.getConfig('isShowInPaymentMultipleDate'))">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(detailInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';

export default {
  data() {
    return {
      paymentType: '1',
      perpetual: Constants,
      detailInfo: [],
      paymentDetailInfo: {},
      pageCount: 1,
      isResult: true,
      totalCost: 0,
      defaultExpandAll: false,
      expands: [],
      tableData: []
    };
  },
  computed: {
    // 处理费用信息
    handleDetail() {
      let handle = [];
      if (this.detailInfo.length > 0) handle = this.$sn.format.group(this.detailInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    },

    // 当前功能 ID
    initial() {
      return [this.perpetual.FUNCTION_ID_MZFY, this.perpetual.FUNCTION_ID_ZYFY][this.paymentType - 1];
    }
  },
  watch: {
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.detailInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.handleDetailInfo();
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.paymentType = this.$route.query.type || '1';
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.initial)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.initial)}详情`;
    this.paymentDetailInfo = this.$sn.utils.getHospitalSessionStorage('payment_Info');
    this.handleDetailInfo();
  },
  methods: {
    // 查询门诊费用详情
    handleDetailInfo() {
      if (this.$sn.validate.empty(this.paymentDetailInfo)) {
        this.isResult = false;
        this.detailInfo = [];
        return false;
      }
      let params = {
        url: Swagger.getPaymentDetail,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          cardNo: this.paymentDetailInfo.cardNo,
          feeDate: this.paymentDetailInfo.feeDate,
          feeId: this.paymentDetailInfo.feeId,
          hosId: this.$sn.utils.getHospitalId(),
          idCardNo: this.paymentDetailInfo.idCard,
          outpID: this.paymentDetailInfo.outpId,
          page: this.pageCount,
          patId: this.paymentDetailInfo.patId,
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          projectType: this.$sn.utils.getProjectType(),
          size: this.perpetual.PAGINATION_SIZE
        })
      };
      if (this.paymentType === '2') {
        params = {
          url: Swagger.getPaymentInInfo,
          method: 'POST',
          header: true,
          data: JSON.stringify({
            cardNo: this.paymentDetailInfo.cardNo,
            feeDate: this.paymentDetailInfo.feeDate,
            feeId: this.paymentDetailInfo.feeId,
            hosId: this.$sn.utils.getHospitalId(),
            idCardNo: this.paymentDetailInfo.idCard,
            outpID: this.paymentDetailInfo.outpId,
            page: this.pageCount,
            patId: this.paymentDetailInfo.patId,
            platformId: this.$sn.utils.getPlatformType(),
            platformUserId: this.$sn.utils.getOpenId(),
            projectType: this.$sn.utils.getProjectType(),
            size: this.$sn.getConfig('isShowInPaymentMultipleDate') ? this.$sn.getConfig('modifyPageSizeMaxLimit') : this.perpetual.PAGINATION_SIZE
          })
        };
      }
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.length > 0) {
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) {
              this.detailInfo = result.data;
              this.totalCost = result.totalFee || 0;
            }
            else this.detailInfo = this.detailInfo.concat(result.data);
            if (this.$sn.getConfig('isShowInPaymentMultipleDate') && this.paymentType === '2') {
              this.isResult = false;
              this.tableData = this.formatData(result.data, 'chargeTime', result.dateTotal);
            }
          }
          else this.isResult = false;
        }
        else {
          this.isResult = false;
          this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
        }
      });
    },
    formatData(data, name, dateTotal) {
      const normalData = [];
      // 合并日期相同的对象到新数组
      data.forEach(el => {
        const isTime = normalData.findIndex(item => {
          return item.time.substring(0, 10) === el[name].substring(0, 10);
        });
        if (isTime === -1) {
          normalData.push({
            time: el[name].substring(0, 10),
            totalCost: 0,
            open: false,
            id: this.$sn.format.guid(),
            children: []
          });
        }
      });
      data.forEach(el => {
        normalData.forEach(item => {
          if (item.time.substring(0, 10) === el[name].substring(0, 10)) {
            item.children.push(el);
            if (!this.$sn.validate.empty(dateTotal)) item.totalCost = dateTotal[item.time.substring(0, 10)];
          }
        });
      });
      // 月 倒序
      this.$sn.format.digitalSort(normalData, '2', 'time');
      // 日 倒序
      normalData.forEach((element, index) => {
        if (index === 0) element.open = true;
        this.$sn.format.digitalSort(element.children, '2', name);
      });
      return normalData;
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.detailInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    openClose(item) {
      this.tableData.forEach(i => {
        i.open = i.id === item.id ? !i.open : false;
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.payment-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: $white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  &-region {
    overflow: hidden;
    height: 100%;
    padding-bottom: 20px;

    .detail-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding: 20px 20px 0;
      display: flex;
      flex-direction: column;

      .total-title {
        font-size: 16px;
        margin: 0 20px 20px;
      }

      .sn-table {
        table {
          table-layout: fixed;
        }

        thead {
          background-color: $background1;

          th {
            color: $text1;
            border-right: 1px solid $white;
            border-radius: 0;

            &:last-child {
              border-right: 1px solid $border1;
            }
          }
        }

        th,
        td {
          @include fs(14);

          height: auto;
          min-height: 30px;
          color: $text1;
        }

        td {
          padding: 10px;
        }
      }

      .table-region {
        overflow-y: auto;

        &-one {
          margin-bottom: 20px;

          .first-header {
            @include fs(16);

            color: $text6;
            padding: 10px;
            background-color: $background2;

            .iconfont {
              font-size: 12px;
            }
          }

          .second {
            .sn-table {
              max-height: 60vh;
            }
          }
        }
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
